export const FEED_OVERRIDES_TAG = 'feed-overrides';

// How long the UI keeps showing the "syncing with the feed" state after a feed-override edit. This is a
// client-side only heads-up (the backend re-import lock is being removed); tune to roughly how long a
// re-import takes to settle.
export const REIMPORT_LOCK_TTL_MS = 2 * 60 * 1000;
